import React from 'react';
export function ContentSection() {
  return <section className="w-full bg-sand-100 py-24 md:py-32 px-6" data-id="element-44">
      <div className="max-w-4xl mx-auto" data-id="element-45">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-46">
          <div data-id="element-47">
            <h3 className="font-serif text-2xl md:text-4xl text-charcoal-700 mb-10 leading-tight uppercase tracking-wide" data-id="element-48">
              Dentro de Florecer vas a encontrar:
            </h3>

            <ul className="space-y-5 text-lg text-charcoal-500 font-light mb-12" data-id="element-49">
              {['Preparación para el parto desde la calma', 'Lactancia explicada de forma simple', 'Cómo entender el llanto de tu bebé', 'Cuidados del recién nacido', 'Situaciones reales del día a día'].map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-50">
                  <span className="text-sage-500 mt-1.5 text-xs" data-id="element-51">●</span>
                  <span data-id="element-52">{item}</span>
                </li>)}
            </ul>

            <p className="font-serif italic text-xl text-warm-500" data-id="element-53">
              Todo explicado de forma clara y aplicable
            </p>
          </div>

          <a href="https://checkout.aulamater.online/cart/44073141076067:1" className="block overflow-hidden transition-opacity duration-500 hover:opacity-90" data-id="element-54">
            <img src="https://cdn.magicpatterns.com/uploads/4jaygYJCiPBM8mEdpwBLeg/e56f482371d632342056a0c28e799912.jpg" alt="Maternidad real" className="w-full h-[500px] object-cover" data-id="element-55" />
          </a>
        </div>
      </div>
    </section>;
}